import { API_BASE, PORTAL_ID } from './api';
import { portalFetchInit } from '../../admin-shared/portalApiAuth';

function fetchInit(extra = {}) {
  return portalFetchInit(PORTAL_ID, {
    headers: { 'Content-Type': 'application/json', ...(extra.headers || {}) },
    ...extra,
  });
}

async function parseJson(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || data.message || `Request failed (${res.status})`);
  }
  return data;
}

export async function listFranchisePriceServices({ includeInactive = true, serviceList = '' } = {}) {
  const params = new URLSearchParams();
  if (includeInactive) params.set('include_inactive', '1');
  if (serviceList) params.set('service_list', serviceList);
  const qs = params.toString() ? `?${params.toString()}` : '';
  const res = await fetch(`${API_BASE}/franchise-price-services${qs}`, fetchInit());
  const data = await parseJson(res);
  return Array.isArray(data.items) ? data.items : [];
}

export async function createFranchisePriceService(payload) {
  const res = await fetch(`${API_BASE}/franchise-price-services`, fetchInit({
    method: 'POST',
    body: JSON.stringify(payload || {}),
  }));
  const data = await parseJson(res);
  return data.item;
}

export async function updateFranchisePriceService(id, payload) {
  const res = await fetch(`${API_BASE}/franchise-price-services/${encodeURIComponent(id)}`, fetchInit({
    method: 'PUT',
    body: JSON.stringify(payload || {}),
  }));
  const data = await parseJson(res);
  return data.item;
}

export async function deleteFranchisePriceService(id, { hard = true } = {}) {
  const qs = hard ? '?hard=1' : '';
  const res = await fetch(
    `${API_BASE}/franchise-price-services/${encodeURIComponent(id)}${qs}`,
    fetchInit({ method: 'DELETE' }),
  );
  return parseJson(res);
}

export async function importPreviewFranchisePriceServices(url, { gender = 'unisex' } = {}) {
  const res = await fetch(`${API_BASE}/franchise-price-services/import-preview`, fetchInit({
    method: 'POST',
    body: JSON.stringify({ url, gender }),
  }));
  return parseJson(res);
}

export async function importFileFranchisePriceServices(file, { gender = 'unisex', serviceList = '' } = {}) {
  const form = new FormData();
  form.append('file', file);
  form.append('gender', gender || 'unisex');
  if (serviceList) form.append('service_list', serviceList);
  const res = await fetch(
    `${API_BASE}/franchise-price-services/import-file`,
    portalFetchInit(PORTAL_ID, {
      method: 'POST',
      body: form,
      // Let browser set multipart boundary — do not force JSON content-type
    }),
  );
  return parseJson(res);
}

export async function importCommitFranchisePriceServices({
  items,
  sourceUrl,
  replaceAll = false,
  serviceList = '',
} = {}) {
  const res = await fetch(`${API_BASE}/franchise-price-services/import-commit`, fetchInit({
    method: 'POST',
    body: JSON.stringify({
      items: items || [],
      source_url: sourceUrl,
      replace_all: Boolean(replaceAll),
      ...(serviceList ? { service_list: serviceList } : {}),
    }),
  }));
  return parseJson(res);
}

export async function getOutletServiceSettings() {
  const res = await fetch(`${API_BASE}/franchise-price-services/outlet-settings`, fetchInit());
  return parseJson(res);
}

export async function submitServiceRequest(payload) {
  const res = await fetch(`${API_BASE}/franchise-price-services/service-requests`, fetchInit({
    method: 'POST',
    body: JSON.stringify(payload || {}),
  }));
  return parseJson(res);
}

export async function listHqServiceCatalog({ query = '', tab = '' } = {}) {
  const params = new URLSearchParams();
  if (query) params.set('q', query);
  if (tab) params.set('tab', tab);
  const qs = params.toString() ? `?${params.toString()}` : '';
  const res = await fetch(`${API_BASE}/franchise-price-services/hq-catalog${qs}`, fetchInit());
  const data = await parseJson(res);
  return Array.isArray(data.items) ? data.items : [];
}

export async function importHqServices(treatmentIds = []) {
  const res = await fetch(`${API_BASE}/franchise-price-services/import-from-hq`, fetchInit({
    method: 'POST',
    body: JSON.stringify({ treatment_ids: treatmentIds || [] }),
  }));
  return parseJson(res);
}
